import { Location } from '@angular/common';
import { computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import {
  signalStore,
  withComputed,
  withMethods,
  withProps,
} from '@ngrx/signals';

export const RouterStore = signalStore(
  { providedIn: 'root' },
  withProps(() => ({
    activatedRoute: inject(ActivatedRoute),
    location: inject(Location),
    router: inject(Router),
  })),
  withComputed(({ activatedRoute, router }) => ({
    currentRoute: computed(() => activatedRoute.snapshot),
    fragment: computed(() => activatedRoute.snapshot.fragment),
    queryParams: computed(() => activatedRoute.snapshot.queryParams),
    routeParams: computed(() => activatedRoute.snapshot.params),
    routeData: computed(() => activatedRoute.snapshot.data),
    url: computed(() => router.url),
    title: computed(() => activatedRoute.snapshot.title),
  })),
  withMethods(({ location, router, activatedRoute }) => ({
    goBack: () => location.back(),
    navigate: (route: any[], extras: any = {}) =>
      router.navigate(route, extras),
    navigateByUrl: (url: string) => router.navigateByUrl(url),
    navigateTo404: () => router.navigate(['/404']),
    navigateToHome: () => router.navigate(['/']),
    reloadCurrentRoute: async (): Promise<void> => {
      const url = router.url;
      const navigationExtras: NavigationExtras = {
        skipLocationChange: true,
      };
      await router.navigate([url], navigationExtras);
    },
    selectQueryParam: (param: string) =>
      activatedRoute.snapshot.queryParams[param],
    selectRouteParam: (param: string) => activatedRoute.snapshot.params[param],
    selectRouteDataParam: (param: string) =>
      activatedRoute.snapshot.data[param],
  })),
);
